import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import getTimeDifference from "../../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../../Common/AllDateTimeReleventFormate";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import GetLocation from "../../../../CustomComponents/GetLocation";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import AbouttheClient from "../../../../Common/AbouttheClient";
import CommonAbouttheClient from "../../../../Common/CommonAbouttheClient";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";

export default function ManageAppliedProjectDetails({ posts }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  return (
    <div className =" project-section project-details p-0">
      <div className ="post-details">
        <div className ="post-flex">
          <div>
            <h5>
              {decodeHtml(posts.title)} <span className ="job">{getPosttype(posts.type)}</span>
            </h5>
            <div className ="dollar-sec">
              <p>
                {/* <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                  alt=""
                /> */}
                <GetPrice
                  type={posts?.type}
                  price={posts?.price}
                  price2={posts?.price2}
                  hiring_type={posts?.hiring_type}
                />
              </p>
              {posts?.type == 3 ? (
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                    alt=""
                  />
                  Job type:
                  {posts?.work_location == 1
                    ? "Virtual"
                    : posts?.work_location == 2
                    ? "Physical"
                    : ""}
                </p>
              ) : (
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                    alt=""
                  />
                  Deadline:&nbsp;
                  {posts?.type == 2 ? (
                    <> {getMemberSince(posts?.last_date)} </>
                  ) : (
                    <>
                      {posts?.duration}&nbsp;
                      {posts?.duration_type == 1
                        ? "Days"
                        : posts?.duration_type == 2
                        ? "Weeks"
                        : posts?.duration_type == 3
                        ? "Months"
                        : ""}
                    </>
                  )}
                </p>
              )}
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                  alt=""
                />
                Posted:{getTimeDifference(posts?.created_on)}
              </p>
            </div>
          </div>
        </div>
        <GetLocation
          type={posts?.type}
          city_name={posts?.city_name}
          country_title={posts?.country_title}
        />
        <CustomeCategoryandSubcategory posts={posts} />

        <div className ="lang-sec">
          <h6>Preferred language</h6>
          <p>{decodeHtml(posts?.language_title)}</p>
        </div>
        <div className ="lang-sec">
          <h6>Description</h6>
          <CustomReactQuillDescription value={posts?.description} />
        </div>
        {Array.isArray(posts?.skills) && posts?.skills.length != 0 && (
          <div className ="lang-sec">
            <h6>Competencies and expertise</h6>
            <div className ="skills-expert">
              <div className ="photoshop">
                {Array.isArray(posts?.skills) &&
                  posts?.skills.map((item1, index1) => (
                    <p key={index1}>{decodeHtml(item1.title)}</p>
                  ))}
              </div>
            </div>
          </div>
        )}
        {Array.isArray(posts?.files) &&
          posts?.files &&
          posts?.files?.length > 0 && (
            <div className ="lang-sec">
              <h6>Attachments</h6>
              <div className ="images">
                {posts?.files &&
                  Array.isArray(posts?.files) &&
                  posts?.files.map((item, index) => {
                    return <DownloadwithDisplayProper item={item} />;
                  })}
              </div>
            </div>
          )}
        <div className ="lang-sec">
          <h6 className ="activity-post"> Activity on this post</h6>
          <div className ="post-p">
           {(Number(posts.price2) !== 0) && <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                alt=""
              />
              Proposal: {posts?.proposal_count}
            </p>}
            {posts?.last_viewed_client && (
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                  alt=""
                />
                Last viewed by client:
                {getTimeDifference(posts?.last_viewed_client)}
              </p>
            )}
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                alt=""
              />
              Seen: {posts?.view_count}
            </p>
          </div>
          <CommonAbouttheClient posts={posts}/>
        </div>
      </div>
    </div>
  );
}
